const WaitPage = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h2>AdSche お申し込み頂きありがとうございます</h2>
      <p>
        再利用のお申し込み、ありがとうございます。内容確認後、管理者よりご連絡致しますので今しばらくお待ちください。
      </p>
    </div>
  );
};

export default WaitPage;